import ApiBack from "../../../../utils/domains/ApiBack";
import IPS from "../../../../models/Ips";
import IPSView from "../../../../models/ipsView";
import Municipio from "../../../../models/municipio";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ServicePrivate from "../../../../services/ServicePrivate";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { MessageToastify } from "../../../../utils/funtions/MessageToastify";
import { useForm } from "../../../../utils/hooks/useForm";
import { useRef } from "react";
import Deparment from "../../../../models/Deparment";
import User from "../../../../models/user";
import { jwtDecode } from "jwt-decode";
import Creditor from "../../../../models/Creditor";
import DateFilterButtons from "../../../component/DateFilterButtons";
import Conciliation from "../../../../models/Conciliation";
import { formatDate } from "../../../../utils/funtions/date";

export const ViewConciliation = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [process, setProcess] = useState<boolean>(false);
    const [selectedIpsName, setselectedIpsName] = useState<string>("");
    const [arrayCreditor, setArrayCreditor] = useState<Creditor[]>([]);
    const [arrayConciliation, setArrayConciliation] = useState<Conciliation[]>([]);
    const [show, setShow] = useState(false);
    const [showData, setShowData] = useState(false);
    const [show2, setShow2] = useState(false);
    const [showUpActivation, setShowUpActivation] = useState(false);
    type formaHtml = React.FormEvent<HTMLFormElement>;
    const handleCloseData = () => setShowData(false);
    const handleClose2 = () => setShow2(false);
    const formRef = useRef<HTMLFormElement>(null);
    const [dataA, setDataA] = useState("");
    const [arrayIPS, setArrayIPS] = useState<IPS[]>([]);
    //function to error the Token on the time, using when token is invalid or expired
    const [arrayUsers, setArrayUsers] = useState<User>();
    const [resumen, setResumen] = useState<any>({});
    const [objIps, setObjIps] = useState<IPS>();
    const [arrayIPSUpdate, setArrayIPSUpdate] = useState<IPS[]>([]);
    const [page, setPage] = useState(1);
    const [isSearchTriggered, setIsSearchTriggered] = useState(false);

    const [sprogramming, setProgramming] = useState("");
    const [dateConciliation, setDateConciliation] = useState("");


    let { id_ips, id_creditor, programming, date_conciliation, modality_conciliation, balance_conciliation, explanation, refund, observations, doubleLink, object } =
        useForm<Conciliation>(
            new Conciliation(
                0,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                ""
            ) // Incluye `id_municipio` con un valor inicial
        );

    const [objips, setObjips] = useState<IPSView>(
        new IPSView(
            0,
            "",
            "",
            false,
            new Municipio(0, "", "", new Deparment(0, "")),
            new Date(),
            false,
            "",
            new Date(), true, true, "", "",new Date()
        )
    );

    // const cleanBox = (form: HTMLFormElement) => {
    //     form.reset();

    //     object.connection = "";
    //     object.password_connection = "";
    //     object.password_server = "";
    //     object.name_server = "";

    //     (form.querySelector('[name="name_solicited"]') as HTMLInputElement).value =
    //         "";
    //     (form.querySelector('[name="role2"]') as HTMLInputElement).value = "";
    //     (form.querySelector('[name="number"]') as HTMLInputElement).value = "";
    //     (form.querySelector('[name="requirement"]') as HTMLInputElement).value = "";

    //     form.classList.remove("was-validated");
    // };

    const getAllIPS = async () => {
        try {
            const results = await ServicePrivate.requestGET(ApiBack.IPS_VIEW_ACTIVE);
            setArrayIPS(results);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching info IPS:", error);
            setLoading(false);
            // handleTokenError(error); // Manejar el error de token
        }
    };
    const getAllCreditor = async () => {
        try {
            const results = await ServicePrivate.requestGET(ApiBack.VIEW_CREDITOR_CONCILIATION);
            setArrayCreditor(results.results);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching info IPS:", error);
            setLoading(false);
            // handleTokenError(error); // Manejar el error de token
        }
    };
    const handleTokenError = () => {
        navigate("/");
    };
    const [startDateEntry, setStartDateEntry] = useState<string>("");
    const [endDateEntry, setEndDateEntry] = useState<string>("");
    const DeleteConci = async (id: number) => {
        try {
            MessageToastify("info", "Seguro que quiere eliminar esta concilicion", 2000);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const getIPSUpdate = async () => {
        try {
            const urlGetMunc = ApiBack.IPS_UPDATE_STATUS;
            const result = await ServicePrivate.requestGET(urlGetMunc);

            if (result) {
                setArrayIPSUpdate(result);
            }
            if (result.error) {
                MessageToastify("error", result.error, 3000)
            }
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };

    const handleShowCreate = async () => {
        setShow2(true);

    }

    const getAllConciliation = async () => {
        try {
            if (selectedIpsName === "") {
                MessageToastify('error', 'Tienes que seleccionar una IPS primero para poder hacer la busqueda.', 2000)
                return;
            }
            if (startDateEntry === "") {
                MessageToastify('error', 'Tienes que seleccionar una fecha de inicio para poder hacer la busqueda.', 2000)
                return;
            }
            if (endDateEntry === "") {
                MessageToastify('error', 'Tienes que seleccionar una fecha de fin para poder hacer la busqueda.', 2000)
                return;
            }

            const url = ApiBack.VIEW_CONCILIATION_ALL + "?ips=" + selectedIpsName + "&date_start=" + startDateEntry + "&date_end=" + endDateEntry
            const results = await ServicePrivate.requestGET(url);
            console.log(results);

            if (results.total_count === 0) {
                MessageToastify('info', 'No hay datos de conciliación para la IPS seleccionada en las fechas indicadas.', 5000)
                return;
            }

            if (results) {
                const payload = results.results || [];
                setArrayConciliation(payload);
                setResumen(results.total_count)
            } else {
                setLoading(true);
            }
        } catch (error) {
            console.error("Error fetching IPS:", error);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const getProfessionals = async () => {
        try {
            const token: any = localStorage.getItem("access");
            if (!token) {
                handleTokenError();
                return;
            }
            const decoded: any = jwtDecode(token);

            if (decoded && decoded.role) {
                setArrayUsers(decoded);
                setLoading(false);
                return;
            } else {
                console.error("El token no contiene información de usuario válida.");
                handleTokenError();
            }

        } catch (error) {
            console.error("Error fetching professionals:", error);
            setLoading(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const downloadTXT = () => {
        if (!arrayConciliation || arrayConciliation.length === 0) {
            MessageToastify('error', 'No hay datos de conciliación para exportar.', 5000);
            return;
        }

        // Convertir cada registro en una línea con |
        const lines = arrayConciliation.map(item => {
            return [
                item.id_creditor__type_creditor,
                item.id_creditor__document_creditor,
                item.programming,
                formatDate(item.date_conciliation),
                item.modality_conciliation,
                item.id_ips__municipio_id__codigo_municipio,
                item.balance_conciliation,
                item.explanation,
                item.refund,
            ].join("|");
        });

        // Unir líneas con salto de línea
        const textContent = lines.join("\n");

        // Crear un archivo descargable
        const blob = new Blob([textContent], { type: "text/plain" });
        const url = URL.createObjectURL(blob);

        // Crear link y descargar
        const link = document.createElement("a");
        link.href = url;
        link.download = "FT038.txt";
        link.click();

        // limpiar memoria
        URL.revokeObjectURL(url);
    }


    const sendForm = async (fh: formaHtml) => {
        try {
            fh.preventDefault();
            setProcess(true);
            const form = fh.currentTarget;

            form.classList.add("was-validated");

            if (form.checkValidity() === false) {
                fh.preventDefault();
                fh.stopPropagation();
                setProcess(false);
                MessageToastify(
                    "error",
                    "Por favor, completa todos los campos requeridos.",
                    7000
                );
                return;
            }

            const formData = {
                id_ips: id_ips,
                programming: programming,
                date_conciliation: dateConciliation,
                modality_conciliation: modality_conciliation,
                balance_conciliation: balance_conciliation,
                explanation: explanation,
                refund: refund,
                observations: observations,
                id_creditor: id_creditor,
            };


            const response = await ServicePrivate.requestPOST(
                ApiBack.CREATE_CONCILIATION,
                formData
            );

            if (!response.ok) {
                setProcess(false);
                MessageToastify(
                    "error",
                    response.error,
                    5000
                );
            } if (response.status === 201) {
                setProcess(false);
                handleClose2();
                getAllIPS();
                MessageToastify("success", "Se creó la conciliación existosamente.", 5000);
            }
        } catch (error) {
            setProcess(false);

            MessageToastify(
                "error",
                "Error por parte del servidor; por favor, comunicarse con TI.",
                2000
            );
        }
    };

    const handleIpsNameChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setselectedIpsName(event.target.value);
    };



    useEffect(() => {
        getAllIPS();
        getProfessionals();
        getIPSUpdate();
        getAllCreditor()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (sprogramming === "False") {
            setDateConciliation("1800-01-01");
        }
    }, [sprogramming])
    return (
        <>
            <div>
                <div className="row">
                    <div className="col-lg-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-6 col-sm-12 col-md-6">
                                        <h4 className="card-title fs-4">
                                            <i className="fa-solid fa-list"></i>&nbsp;Busqueda de conciliaciones
                                        </h4>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-md-6">
                                        <div className="d-flex justify-content-center justify-content-md-end py-2 p-md-0">
                                            <button
                                                className={
                                                    "badge fs-6 py-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                                }
                                                type="button"
                                                onClick={() => handleShowCreate()}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Crear
                                            </button>
                                            <button
                                                className={
                                                    "badge fs-6 py-1 pe-2 text-info-emphasis bg-info-subtle border border-info-subtle rounded-pill"
                                                }
                                                type="button"
                                                onClick={() => downloadTXT()}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <i className="fa-solid fa-file"></i>&nbsp;FT038
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="d-flex align-items-center col-lg-8 col-md-12">
                                            <Form.Group className="" controlId="formIps">
                                                <Form.Label className="fw-bold">Seleccionar IPS</Form.Label>
                                                <Form.Select
                                                    value={selectedIpsName}
                                                    onChange={handleIpsNameChange}
                                                    onClick={() => {
                                                        //   setArrayAuthDevice([]);
                                                        setPage(0);
                                                        //   setlimit(0);
                                                        //   setTotal(0);
                                                    }}
                                                >
                                                    <option value="">Todas las IPS</option>
                                                    {arrayIPS.map((type) => (
                                                        <option key={type.id} value={type.id}>
                                                            {type.municipio_id.nombre_municipio}&nbsp;-&nbsp;
                                                            {type.nombre_ips}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                            <Form.Group className="" controlId="startDateEntry">
                                                <Form.Label className="fw-bold">Fecha de inicio</Form.Label>
                                                <Form.Control
                                                    required
                                                    type="date"
                                                    // id="startDateEntry"
                                                    value={startDateEntry}
                                                    onChange={(e) => setStartDateEntry(e.target.value)}
                                                    onClick={() => {
                                                        //   setArrayAuthDevice([]);
                                                        setPage(0);
                                                        //   setlimit(0);
                                                        //   setTotal(0);
                                                    }}
                                                />
                                            </Form.Group>
                                            <Form.Group className="" controlId="startDateEntry">
                                                <Form.Label className="fw-bold">Fecha de fin</Form.Label>
                                                <Form.Control
                                                    required
                                                    type="date"
                                                    value={endDateEntry}
                                                    onChange={(e) => setEndDateEntry(e.target.value)}
                                                    onClick={() => {
                                                        //   setArrayAuthDevice([]);
                                                        setPage(0);
                                                        //   setlimit(0);
                                                        //   setTotal(0);
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="d-flex align-items-center mt-lg-4 col-lg-4 col-sm-12 col-md-12 mb-3">
                                            <DateFilterButtons
                                                setStartDateEntry={setStartDateEntry}
                                                setEndDateEntry={setEndDateEntry}
                                                setIsSearchTriggered={setIsSearchTriggered}
                                                setPage={setPage}
                                                getMySupports={getAllConciliation}
                                                page={page}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row d-flex justify-center">
                                    <div className="col-lg-3 col-md-6">
                                        <p>
                                            Total de conciliaciones el la busqueda:&nbsp;
                                            <b className="fw-bold">{Array.isArray(arrayConciliation) ? arrayConciliation.length : 0}</b>
                                        </p>

                                    </div>
                                </div>

                                <div className="table-responsive rounded-table" style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto",
                                    zIndex: 1020
                                }}>

                                    <table className="table table-striped table-sm table-hover table-sm">
                                        <thead className="table-dark " style={{ position: "sticky", top: 0, zIndex: 10 }}>
                                            <tr>
                                                <th style={{ width: "15%", cursor: "pointer" }} >Acreedor</th>
                                                <th style={{ width: "10%" }}>Fecha</th>
                                                <th style={{ width: "5%" }}>Programación</th>
                                                <th style={{ width: "15%" }}>Modalidad</th>
                                                <th style={{ width: "15%" }}>Saldo</th>
                                                <th style={{ width: "15%" }}>Glosa</th>
                                                <th style={{ width: "15%" }}>Devolución</th>
                                                <th style={{ width: "5%" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-group-divider ">
                                            {arrayConciliation?.map((myCreditor, count) => (
                                                <tr key={count + 1}>
                                                    <td>{myCreditor.id_creditor__name_creditor}</td>
                                                    <td>{formatDate(myCreditor.date_conciliation)}</td>
                                                    <td>{myCreditor.programming ? "Sí" : "No"}</td>
                                                    <td>  {{
                                                        1: "Presencial",
                                                        2: "Virtual",
                                                        3: "No aplica"
                                                    }[myCreditor.modality_conciliation] || "Desconocido"}</td>
                                                    <td>{myCreditor.balance_conciliation}</td>
                                                    <td>{myCreditor.explanation}</td>
                                                    <td>{myCreditor.refund}</td>
                                                    <td>
                                                        <button
                                                            className={`badge fs-6 bg-info-subtle border p-1 pe-1 border-info-subtle text-info-emphasis rounded-pill"
                                                                }`}
                                                            onClick={() => {
                                                                navigate(`/home/list-cons-pacts/${myCreditor.id}/${myCreditor.id_creditor__name_creditor}/${myCreditor.id_ips__nombre_ips}/${myCreditor.programming}/${myCreditor.date_conciliation}/${myCreditor.modality_conciliation}/${myCreditor.balance_conciliation}/${myCreditor.explanation}/${myCreditor.refund}/${myCreditor.id_creditor__type_creditor}/${myCreditor.id_creditor__document_creditor}/${myCreditor.id_ips__municipio_id__codigo_municipio}`);
                                                            }}
                                                        // disabled={!myCreditor.is_active}
                                                        >
                                                            P
                                                        </button>
                                                        &nbsp;
                                                        {arrayUsers?.role === "ADMINISTRADOR" ? (
                                                            <>
                                                                <button
                                                                    className={
                                                                        "badge fs-6 bg-danger-subtle border p-1 pe-1 border-danger-subtle text-danger-emphasis rounded-pill"}
                                                                    type="button"
                                                                    onClick={() => DeleteConci(myCreditor.id)}

                                                                >
                                                                   <i className="fa-solid fa-ban"></i>
                                                                </button>
                                                            </>
                                                        ) : ("")}

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex align-items-center justify-content-center m-3"></div>
                                </div>


                                <Modal
                                    show={showData}
                                    onHide={handleCloseData}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    size="xl"
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-center fw-bold">
                                            Datos de la ips
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Card className="mt-0 border-0 shadow-none">
                                            {/* card body */}
                                            <Card.Body>
                                                {/* card title */}
                                                <Card.Title
                                                    as="h4"
                                                    className="d-flex justify-content-center fs-2"
                                                >
                                                    <i className="fa-solid fa-hospital-user"></i>
                                                    &nbsp;IPS
                                                </Card.Title>
                                                <span
                                                    className="text-uppercase fw-lighter  fs-6 ls-2"
                                                    style={{ color: "#0f0f70" }}
                                                >
                                                    <i className="fa-solid fa-clipboard-check"></i> Nombre de la ips:{" "}
                                                    <p className="fw-semibold text-black fs-5">
                                                        {objIps?.nombre_ips}
                                                    </p>
                                                </span>
                                                <Row>
                                                    <Col xs={8} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fs-6 fw-lighter ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-id-card"></i> Código Ips
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.cod_ips}
                                                        </p>
                                                    </Col>
                                                    <Col xs={4} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fs-6 fw-lighter ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-solid fa-calendar"></i> Contrato S/C
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.date_contract
                                                                ? new Date(`${objIps.date_contract}T00:00:00`).toLocaleString(
                                                                    "es-CO",
                                                                    {
                                                                        year: "numeric",
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                    }
                                                                )
                                                                : "No Tiene contrato"}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-envelope"></i> Fecha de actualización y actualizado
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.date_update2025
                                                                ? new Date(`${objIps.date_contract}T00:00:00`).toLocaleString(
                                                                    "es-CO",
                                                                    {
                                                                        year: "numeric",
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                    }
                                                                )
                                                                : "No Tiene actualización"}&nbsp;
                                                            {objIps?.date_updated
                                                                ? new Date(`${objIps.date_updated}T00:00:00`).toLocaleString(
                                                                    "es-CO",
                                                                    {
                                                                        year: "numeric",
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                    }
                                                                )
                                                                : "No Tiene actualizada"}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-envelope"></i> Conexión
                                                        </h6>
                                                        <p className="text-uppercase fw-semibold fs-5 text-black">
                                                            {objIps?.connection}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-solid fa-phone-volume"></i> Contraseña de la conexión
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.password_connection}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-solid fa-phone-volume"></i> Nombre del servidor
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.name_server}
                                                        </p>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-envelope"></i> Contraseña del servidor
                                                        </h6>
                                                        <p className="text-uppercase fw-semibold fs-5 text-black">
                                                            {objIps?.password_server}
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            variant="danger"
                                            onClick={() => {
                                                setShowData(false);
                                            }}
                                        >
                                            <i className="fa-solid fa-backward"></i>
                                            &nbsp;Cerrar
                                        </Button>
                                    </Modal.Footer>
                                </Modal>


                                <Modal
                                    show={show2}
                                    onHide={handleClose2}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    size="lg"
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-center fw-bold">
                                            <i className="fa-solid fa-folder-plus"></i>
                                            &nbsp;Formulario de creación
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Form
                                        className="forms-sample"
                                        validated={process}
                                        onSubmit={sendForm}
                                        noValidate
                                        ref={formRef}
                                    >
                                        <Modal.Body>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    {/* Campo para nombre_ips */}
                                                    <Form.Group controlId="programming" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="programming"
                                                        >
                                                            Programación:
                                                        </Form.Label>
                                                        <Form.Select
                                                            required
                                                            id="programming"
                                                            name="programming"
                                                            value={programming}
                                                            onChange={(e) => {
                                                                doubleLink(e);
                                                                setProgramming(e.target.value);
                                                            }}
                                                        >
                                                            <option value="">Seleccione la programación</option>
                                                            <option value="True">Si</option>
                                                            <option value="False">No</option>

                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">
                                                            Nombre del acreedor es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    {/* Campo para cod_ips */}
                                                    <Form.Group controlId="date_conciliation" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="date_conciliation"
                                                        >
                                                            Fecha de conciliación:
                                                        </Form.Label>
                                                        {sprogramming === "False" ? (
                                                            <p className="text-secondary fst-italic">
                                                                No tiene programación, por lo tanto la fecha de conciliación se establece en 1800-01-01
                                                            </p>
                                                        ) : (
                                                            <>
                                                                <Form.Control
                                                                    required
                                                                    type="date"
                                                                    name="date_conciliation"
                                                                    className="form-control"
                                                                    id="date_conciliation"
                                                                    placeholder="Escriba el tipo de acreedor"
                                                                    value={date_conciliation}
                                                                    onChange={(e) => {
                                                                        doubleLink(e);
                                                                        setDateConciliation(e.target.value);
                                                                    }}
                                                                    readOnly={sprogramming === "False"}
                                                                    autoComplete="off"
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    El tipo de acreedor es obligatorio.
                                                                </Form.Control.Feedback>
                                                            </>)}

                                                    </Form.Group>

                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="modality_conciliation" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="modality_conciliation"
                                                        >
                                                            Modalidad de conciliación:
                                                        </Form.Label>
                                                        <Form.Select
                                                            required
                                                            id="modality_conciliation"
                                                            name="modality_conciliation"
                                                            value={modality_conciliation}
                                                            onChange={doubleLink}
                                                        >
                                                            <option value="">Seleccione la modalidad</option>
                                                            <option value="1">Presencial</option>
                                                            <option value="2">Virtual</option>
                                                            {sprogramming === "False" && (
                                                                <option value="3">No aplica</option>
                                                            )}

                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">
                                                            El documento del acreedor es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="balance_conciliation" className="mb-3 w-100">
                                                        <Form.Label className="fw-bold mb-2 mt-2">Saldo:</Form.Label>

                                                        <Form.Control
                                                            required
                                                            type="text"
                                                            name="balance_conciliation"
                                                            placeholder="Escriba el saldo de la conciliación"
                                                            value={
                                                                balance_conciliation
                                                                    ? `COP ${parseInt(balance_conciliation).toLocaleString("es-CO")}`
                                                                    : ""
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                // Extraer solo números
                                                                const onlyNumbers = value.replace(/\D/g, "");

                                                                // Limitar longitud
                                                                if (onlyNumbers.length <= 15) {
                                                                    const fakeEvent = {
                                                                        ...e,
                                                                        target: {
                                                                            ...e.target,
                                                                            value: onlyNumbers,
                                                                            name: e.target.name,
                                                                        },
                                                                    };

                                                                    doubleLink(fakeEvent);
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="explanation" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="explanation"
                                                        >
                                                            Glosa:
                                                        </Form.Label>
                                                        <Form.Control
                                                            required
                                                            type="text"
                                                            name="explanation"
                                                            className="form-control"
                                                            id="explanation"
                                                            placeholder="Escriba la glosa de la conciliación"
                                                            value={
                                                                explanation
                                                                    ? `COP ${parseInt(explanation).toLocaleString("es-CO")}`
                                                                    : ""
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                // Extraer solo números
                                                                const onlyNumbers = value.replace(/\D/g, "");

                                                                // Limitar longitud
                                                                if (onlyNumbers.length <= 15) {
                                                                    const fakeEvent = {
                                                                        ...e,
                                                                        target: {
                                                                            ...e.target,
                                                                            value: onlyNumbers,
                                                                            name: e.target.name,
                                                                        },
                                                                    };

                                                                    doubleLink(fakeEvent);
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="refund" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="refund"
                                                        >
                                                            Devolución:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="refund"
                                                            className="form-control"
                                                            id="refund"
                                                            placeholder="Escriba la devolución de la conciliación"
                                                            value={
                                                                refund
                                                                    ? `COP ${parseInt(refund).toLocaleString("es-CO")}`
                                                                    : ""
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                // Extraer solo números
                                                                const onlyNumbers = value.replace(/\D/g, "");

                                                                // Limitar longitud
                                                                if (onlyNumbers.length <= 15) {
                                                                    const fakeEvent = {
                                                                        ...e,
                                                                        target: {
                                                                            ...e.target,
                                                                            value: onlyNumbers,
                                                                            name: e.target.name,
                                                                        },
                                                                    };

                                                                    doubleLink(fakeEvent);
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    {/* Campo para seleccionar municipio */}
                                                    <Form.Group
                                                        controlId="id_ips"
                                                        className="mb-3 w-100"
                                                    >
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="id_ips"
                                                        >
                                                            Ips:
                                                        </Form.Label>
                                                        <Form.Select
                                                            required
                                                            id="id_ips"
                                                            name="id_ips"
                                                            value={id_ips}
                                                            onChange={doubleLink}
                                                        >
                                                            <option value="">Seleccione la IPS</option>
                                                            {arrayIPS.map((ips) => (
                                                                <option key={ips.id} value={ips.id}>
                                                                    {ips.nombre_ips}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">
                                                            EL municipio es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group
                                                        controlId="id_creditor"
                                                        className="mb-3 w-100"
                                                    >
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="id_creditor"
                                                        >
                                                            Acreedor:
                                                        </Form.Label>
                                                        <Form.Select
                                                            required
                                                            id="id_creditor"
                                                            name="id_creditor"
                                                            value={id_creditor}
                                                            onChange={doubleLink}
                                                        >
                                                            <option value="">Seleccione el acreedor</option>
                                                            {arrayCreditor.map((creditor) => (
                                                                <option key={creditor.id} value={creditor.id}>
                                                                    {creditor.name_creditor}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">
                                                            EL municipio es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>
                                            </div>

                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="danger" onClick={handleClose2}>
                                                <i className="fa-solid fa-backward"></i>&nbsp;Cancelar
                                            </Button>
                                            <Button
                                                variant="success"
                                                type="submit"
                                                onClick={() => { }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Guardar
                                            </Button>
                                        </Modal.Footer>
                                    </Form>
                                </Modal>


                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    );
};
